<lib-audit-report-request-modal *ngIf="showAuditReportRequestModal"
                                 [showModal]=showAuditReportRequestModal
                                 [enterpriseId]="enterpriseId"
                                 [enterpriseLabels]="enterpriseLabels"
                                 (isRequestingAuditReport)=handleAuditReportRequest($event)>
</lib-audit-report-request-modal>
<div class="row">
    <div class="d-flex justify-content-end mb-2">
        <lib-business-history [eventCategory]="eventCategory"
                              [enterpriseId]="enterpriseId" [enterpriseLabels]="enterpriseLabels">
        </lib-business-history>
    </div>
    <div class="d-flex justify-content-end p-2">
        <button data-identifier="uid-audit-reports-request" type="button"
                class="btn btn-sm btn-primary" (click)="requestAuditReport()">Request Audit Report
        </button>
        <button data-identifier="uid-audit-reload-data" type="button"
                class="btn btn-outline-primary mx-md-2" (click)="reloadData()">Reload Data
        </button>
    </div>
</div>
